import React, { useState, useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/all";
import Logo from "../../assets/ek.png";
import Linkedin from "../../assets/linkedin.png";
import Github from "../../assets/github.png";
import TopRight from "../../assets/top-right.png";
import Menu from "../../assets/menu.png";
import Close from "../../assets/close.svg";
import Button from "../Utilities/Button";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
gsap.registerPlugin(ScrollToPlugin);
const Navbar = () => {
  const [mobileNav, setmobileNav] = useState(false);
  const mobileRef = useRef(null);
  const navRef = useRef(null);
  let location = useLocation();

  const toggleNav = () => {
    setmobileNav((prev) => !prev);
  };

  const scrollTo = (target) => {
    gsap.to(window, {
      duration: 2,
      scrollTo: { y: target, offsetY: 100 },
    });
  };

  useEffect(() => {
    gsap.fromTo(
      navRef.current,
      {
        opacity: 0,
        delay: 3,
      },
      {
        opacity: 1,
        duration: 2,
      }
    );
  }, []);
  return (
    <div id="navbar" className="bg-N0 font-sans relative" ref={navRef}>
      <img
        src={TopRight}
        alt="top right"
        className=" absolute top-0 opacity-80 md:-top-2 z-0 left-0 w-48 md:w-72"
      />

      <ul
        ref={mobileRef}
        className={`absolute text-N99 p-4 flex flex-col items-center justify-center space-y-3 max-w-xs md:hidden  w-[70%] bg-[#0a0a0a] shadow-md rounded-md left-1/2 -translate-x-1/2 capitalize z-50 transition-all duration-[700ms] ease-in-out min-h-[30vh] ${
          mobileNav ? "top-10" : "-top-[420%]"
        }`}
      >
        {location.pathname === "/" ? (
          <>
            <li onClick={() => scrollTo("#projects")}>projects</li>
            <li onClick={() => scrollTo("#about")}>About</li>
            <li onClick={() => scrollTo("#skills")}>Skills</li>
            <li onClick={() => scrollTo("#blog")}>Blogs</li>
          </>
        ) : (
          <></>
        )}

        <Link to="/contact">
          <Button variant="outline" custom="w-max border-primary50 py-2">
            contact
          </Button>
        </Link>
      </ul>
      <div className="layout py-4 md:py-6 flex items-center gap-4 sm:gap-8 md:gap-12 lg:gap-16 xl:gap-24 2xl:gap-32 md:justify-start justify-between w-full">
        <div className="flex items-center justify-between w-full sm:w-2/3 md:w-1/2">
          <Link to="/">
            <img src={Logo} className=" relative z-10 h-8 lg:h-12" alt="logo" />
          </Link>
          <div className="flex items-center gap-4 md:gap-6 opacity-80">
            <a
              href="https://github.com/eyujunior"
              rel="noreferrer"
              target="_blank"
            >
              <img
                className="h-5 cursor-pointer hover:scale-105 transition-all duration-200 ease-in-out"
                src={Github}
                alt="github logo"
              />
            </a>
            <a
              href="https://www.linkedin.com/in/eyobel-kirub-3bb011192/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="sm:h-8 h-7 cursor-pointer hover:scale-105 transition-all duration-200 ease-in-out"
                src={Linkedin}
                alt="linkedin logo"
              />
            </a>
          </div>
        </div>
        <nav className="items-center justify-end w-1/2 gap-8 hidden md:flex">
          {location.pathname === "/" ? (
            <ul className="flex items-center text-N90 font-light 2xl:text-lg gap-8 xl:gap-12 2xl:gap-16 capitalize">
              <li
                onClick={() => scrollTo("#projects")}
                className="hover:text-N99 font-normal cursor-pointer transition-all duration-200 ease-in"
              >
                projects
              </li>
              <li
                onClick={() => scrollTo("#skills")}
                className="hover:text-N99 font-normal cursor-pointer transition-all duration-200 ease-in"
              >
                skills
              </li>
              <li
                onClick={() => scrollTo("#about")}
                className="hover:text-N99 font-normal cursor-pointer transition-all duration-200 ease-in"
              >
                about
              </li>
              <li
                onClick={() => scrollTo("#blog")}
                className="hover:text-N99 font-normal cursor-pointer transition-all duration-200 ease-in"
              >
                Blog
              </li>
            </ul>
          ) : (
            <></>
          )}

          <Link to="/contact">
            <Button variant="outline" custom="w-max border-primary50/20 py-2">
              contact
            </Button>
          </Link>
        </nav>
        {mobileNav ? (
          <img
            src={Close}
            onClick={toggleNav}
            alt="menu"
            className="md:hidden block h-6"
          />
        ) : (
          <img
            src={Menu}
            onClick={toggleNav}
            alt="menu"
            className="md:hidden block h-7"
          />
        )}
      </div>
    </div>
  );
};

export default Navbar;
